import { createI18n } from "vue-i18n";

const messages = {
  pl: {
    header: {
      calculator: "Kalkulator",
      logout: "Wyloguj",
      logoutFull: "Wyloguj się",
    },
    login: {
      title: "Logowanie",
      emailPlaceholder: "Imię lub e-mail",
      emailName: "e-mail",
      passwordName: "hasło",
      passwordPlaceholder: "Proszę wprowadzić hasło",
      submit: "Zaloguj się",
      errorEmailEmpty: "Pole 'Imię lub e-mail' nie może być puste!",
      errorPasswordEmpty: "Pole 'Hasło' nie może być puste!",
      errorPasswordShort: "Hasło musi mieć co najmniej 6 znaków!",
      errorAccountNotFound: "Nie znaleziono konta z takimi danymi!",
    },
    calculator: {
      selectVehicle: "Wybierz pojazd",
      linkPlaceholder: "Link Copart / IAAI lub VIN...",
      scan: "Skanuj",
      dealerPlaceholder: "Dealer...",
      tabCalculator: "Kalkulator",
      tabAnalytics: "Analiza VIN",
      noExcise: "! Brak akcyzy !",
      hide: "UKRYJ",
      fullText: "PEŁNA TREŚĆ",
      kwh: "kW/h",
      engineCapacity: "Pojemność silnika",
      fuelType: "Rodzaj paliwa",
      saleStatus: "Status sprzedaży",
      deliveryPort: "Port dostawy",
      yearOfProduction: "Rok produkcji",
      finalBid: "Ostateczna stawka",
      auctionFee: "Opłata aukcyjna",
      delivery: "Dostawa {port}",
      transportToPoland: "Transport do Polski",
      customsClearance: "Odprawa celna",
      rotterdamComplex: "Kompleks Rotterdam",
      companyServices: "Usługi firmy",
      otherFees: "Inne opłaty",
      unitYear: "ROK",
      sizeCrossover: "Crossover",
      sizeBig: "Wielkogab.",
      sizeNonStandard: "Niestand.",
      document: "Dokument:",
      goodForExport: "good for export",
      riskyDocuments: "Ryzykowne dokumenty lub brak licencji.",
      sublotStatus: "Status Sublot:",
      sublotWarning: "Uwaga: SUBLOT!",
      sublotStandard: "Standard",
      sublotNote: "* Sublot oznacza dodatkowe koszty transportu lokalnego (zazwyczaj +100-250$)",
      fromInsurer: "POJAZD OD UBEZPIECZYCIELA",
      fromDealer: "POJAZD OD DEALERA",
      fromInsurerNote: "Zazwyczaj oznacza szkody powypadkowe lub całkowite.",
      fromDealerNote: "Często w lepszym stanie wizualnym i technicznym.",
      vinVerification: "Weryfikacja VIN",
      sixDigits: "6 cyfr",
      insurance: "Ubezpieczenie (2%)",
      terms: "Regulamin",
      totalEstimated: "Całkowity koszt szacunkowy",
      priceNote: "* Cena pod dom bez akcyzy",
      avgPrice: "Średnia cena",
      minPrice: "Minimalna",
      maxPrice: "Maksymalna",
      reserve: "Rezerwa",
      lot: "Lot #",
      photo: "Zdjęcie",
      status: "Status",
      price: "Cena",
      date: "Data",
      notifyParseError: "Błąd podczas pobierania danych",
      notifyVinCopied: "VIN skopiowany!",
      notifyLinkCopied: "Link do wyceny skopiowany!",
    },
    carfax: {
      header: "Aby uzyskać raport Car Fax, wprowadź numer VIN pojazdu.",
      vinPlaceholder: "Kod VIN",
      scan: "Skanuj",
      download: "Pobierz Car Fax",
      notifyTitle: "Komunikat systemowy!",
      notifyVinLength: "Kod VIN musi mieć 17 znaków, proszę sprawdzić!",
    },
    port: {
      header: "Wprowadź numer VIN pojazdu",
      vinPlaceholder: "Kod VIN",
      scan: "Skanuj",
      info: "Informacje",
      saveAllPhotos: "Zapisz wszystkie zdjęcia",
      notifyTitle: "Komunikat systemowy!",
      notifyError: "Nie udało się, spróbuj z innym kodem VIN!",
    },
    news: {
      header: "Najnowsze wiadomości",
    },
    share: {
      vinCode: "Kod VIN",
      lastDigitsPlaceholder: "Wprowadź ostatnie cyfry",
      yearOfProduction: "Rok produkcji",
      checkYearNote: "Sprawdź rok produkcji na zdjęciu tabliczki",
      finalPriceUsd: "Ostateczna cena USD",
      auctionFee: "Opłata aukcyjna",
      checkCanadaNote: "Sprawdź informacje dla Kanady",
      transportToPort: "Transport do portu ({port})",
      transportToPortPlaceholder: "Transport do portu",
      timeFeesNote: "Dodatkowe płatności czasowe nie są uwzględnione",
      bigVehicleFee: "Dodatkowa opłata za duże pojazdy",
      crossover: "Crossover",
      bigSize: "Duży rozmiar",
      nonStandard: "Niestandardowy",
      insuranceFromPhoto: "Ubezpieczenie na podstawie zdjęcia z aukcji",
      parkingKlaipeda: "Parking w Kłajpedzie",
      parkingKlaipedaPlaceholder: "Parking w Kłajpedzie na 5 dni",
      expedition: "Ekspedycja, T-1, załadunek",
      transportKlaipedaLviv: "Transport Kłajpeda - Lwów, broker",
      customsCost: "Koszt odprawy celnej w {year} roku",
      certification: "Certyfikacja (średni koszt)",
      pensionFund: "Opłata do Funduszu Emerytalnego",
      companyServices: "Usługi firmy",
      totalCost: "Łączny koszt",
    },
    modal: {
      ok: "OK",
    },
  },
  en: {
    header: {
      calculator: "Calculator",
      logout: "Log out",
      logoutFull: "Log out",
    },
    login: {
      title: "Sign in",
      emailPlaceholder: "Name or e-mail",
      emailName: "e-mail",
      passwordName: "password",
      passwordPlaceholder: "Please enter your password",
      submit: "Sign in",
      errorEmailEmpty: "The 'Name or e-mail' field cannot be empty!",
      errorPasswordEmpty: "The 'Password' field cannot be empty!",
      errorPasswordShort: "Password must be at least 6 characters!",
      errorAccountNotFound: "No account found with these credentials!",
    },
    calculator: {
      selectVehicle: "Select a vehicle",
      linkPlaceholder: "Copart / IAAI link or VIN...",
      scan: "Scan",
      dealerPlaceholder: "Dealer...",
      tabCalculator: "Calculator",
      tabAnalytics: "VIN analysis",
      noExcise: "! No excise duty !",
      hide: "HIDE",
      fullText: "FULL TEXT",
      kwh: "kW/h",
      engineCapacity: "Engine capacity",
      fuelType: "Fuel type",
      saleStatus: "Sale status",
      deliveryPort: "Delivery port",
      yearOfProduction: "Year of production",
      finalBid: "Final bid",
      auctionFee: "Auction fee",
      delivery: "Delivery {port}",
      transportToPoland: "Transport to Poland",
      customsClearance: "Customs clearance",
      rotterdamComplex: "Rotterdam complex",
      companyServices: "Company services",
      otherFees: "Other fees",
      unitYear: "YEAR",
      sizeCrossover: "Crossover",
      sizeBig: "Oversized",
      sizeNonStandard: "Non-std.",
      document: "Document:",
      goodForExport: "good for export",
      riskyDocuments: "Risky documents or no license.",
      sublotStatus: "Sublot status:",
      sublotWarning: "Warning: SUBLOT!",
      sublotStandard: "Standard",
      sublotNote: "* Sublot means additional local transport costs (usually +100-250$)",
      fromInsurer: "VEHICLE FROM INSURER",
      fromDealer: "VEHICLE FROM DEALER",
      fromInsurerNote: "Usually means accident or total loss damage.",
      fromDealerNote: "Often in better visual and technical condition.",
      vinVerification: "VIN verification",
      sixDigits: "6 digits",
      insurance: "Insurance (2%)",
      terms: "Terms",
      totalEstimated: "Total estimated cost",
      priceNote: "* Price to your door, excluding excise duty",
      avgPrice: "Average price",
      minPrice: "Minimum",
      maxPrice: "Maximum",
      reserve: "Reserve",
      lot: "Lot #",
      photo: "Photo",
      status: "Status",
      price: "Price",
      date: "Date",
      notifyParseError: "Error while fetching data",
      notifyVinCopied: "VIN copied!",
      notifyLinkCopied: "Quote link copied!",
    },
    carfax: {
      header: "To get a Car Fax report, enter the vehicle's VIN number.",
      vinPlaceholder: "VIN code",
      scan: "Scan",
      download: "Download Car Fax",
      notifyTitle: "System message!",
      notifyVinLength: "The VIN code must be 17 characters, please check!",
    },
    port: {
      header: "Enter the vehicle's VIN number",
      vinPlaceholder: "VIN code",
      scan: "Scan",
      info: "Information",
      saveAllPhotos: "Save all photos",
      notifyTitle: "System message!",
      notifyError: "Something went wrong, try another VIN code!",
    },
    news: {
      header: "Latest news",
    },
    share: {
      vinCode: "VIN code",
      lastDigitsPlaceholder: "Enter the last digits",
      yearOfProduction: "Year of production",
      checkYearNote: "Check the year of production on the plate photo",
      finalPriceUsd: "Final price USD",
      auctionFee: "Auction fee",
      checkCanadaNote: "Check information for Canada",
      transportToPort: "Transport to port ({port})",
      transportToPortPlaceholder: "Transport to port",
      timeFeesNote: "Additional time-based payments are not included",
      bigVehicleFee: "Additional fee for large vehicles",
      crossover: "Crossover",
      bigSize: "Large size",
      nonStandard: "Non-standard",
      insuranceFromPhoto: "Insurance based on the auction photo",
      parkingKlaipeda: "Parking in Klaipeda",
      parkingKlaipedaPlaceholder: "Parking in Klaipeda for 5 days",
      expedition: "Expedition, T-1, loading",
      transportKlaipedaLviv: "Transport Klaipeda - Lviv, broker",
      customsCost: "Customs clearance cost in {year}",
      certification: "Certification (average cost)",
      pensionFund: "Pension Fund contribution",
      companyServices: "Company services",
      totalCost: "Total cost",
    },
    modal: {
      ok: "OK",
    },
  },
};

const savedLocale = localStorage.getItem("locale") || "pl";

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: "pl",
  messages,
});

export default i18n;
